import React from 'react'
import FilterLabel from './FilterLabel.jsx'

export default function Selections ({ selections, updateSelection, updateSearchTerms }) {
  return (
    <div className="c-searchSelections">
      {
        selections.map(selection => {
          return <FilterLabel selection={selection} updateSelection={updateSelection} updateSearchTerms={updateSearchTerms} />
        })
      }
    </div>
  )
}